import { plainToInstanceWithLVS } from '@goparrot/common';
import { ReadVendorDto } from '../generated-dto';
import { VendorExposeGroup } from '../interface';
import { BaseVendorFacade } from './BaseVendorFacade';
export class VendorFacade extends BaseVendorFacade {
    constructor() {
        super(...arguments);
        this.baseUrl = 'api/v2/vendors';
    }
    async list(params = {}) {
        const plainData = (await this.client.get(this.baseUrl, {
            params: { ...params, ...(params.provider && Array.isArray(params.provider) ? { provider: params.provider.join('|') } : {}) },
        })).data;
        return {
            ...plainData,
            rows: plainToInstanceWithLVS(ReadVendorDto, plainData.rows, { groups: [VendorExposeGroup.READ] }),
        };
    }
    async create(payload) {
        return plainToInstanceWithLVS(ReadVendorDto, (await this.client.post(this.baseUrl, payload)).data, { groups: [VendorExposeGroup.READ] });
    }
    async get(storeId) {
        return plainToInstanceWithLVS(ReadVendorDto, (await this.client.get(`${this.baseUrl}/${storeId}`)).data, {
            groups: [VendorExposeGroup.READ],
        });
    }
    async patch(storeId, operations) {
        return plainToInstanceWithLVS(ReadVendorDto, (await this.client.patch(`${this.baseUrl}/${storeId}`, operations)).data, {
            groups: [VendorExposeGroup.READ],
        });
    }
    async delete(storeId) {
        await this.client.delete(`${this.baseUrl}/${storeId}`);
    }
}
//# sourceMappingURL=VendorFacade.js.map